module.exports = __webpack_public_path__ + "components/country-flag/static/ng-0ecd30224e9379c77311b564911d6d8a.svg";